export const SelectsList = [];

export function handleWindow() {
  window.addEventListener('click', () => {
    SelectsList.forEach((obj) => {
      obj.toggle(false);
    });
  });
}

export function handleTrigger(obj) {
  const button = obj.trigger;

  button.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    SelectsList.forEach((select) => {
      if (select !== obj) {
        select.toggle(false);
      }
    });

    if (!obj.select.classList.contains('collapsed')) {
      obj.toggle(true);
    } else {
      obj.toggle(false);
    }
  });
}

export function handleOptions(obj, filter = false) {
  const multiple = obj.select.classList.contains('site-select-multiple');

  const { options } = obj;

  options.forEach((option) => {
    const value = option.dataset ? option.dataset.value || '' : '';
    const text = option.textContent;

    option.addEventListener('click', (event) => {
      event.stopPropagation();

      if (multiple) {
        const remove = option.classList.contains('active');

        obj.value = { value, text, remove };
      } else {
        obj.value = { value, text, remove: false };
      }

      if (!multiple) {
        setTimeout(() => obj.toggle(false), 400);
      }

      if (filter) {
        if (value !== filter.previous) filter.form.submit();
      }
    });
  });
}
